import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useConfig } from "../lib/useConfig";
import useToken from "../lib/useToken";

const addProductToCart = async (
  variables: { giftcardId: string; amount?: number },
  customerToken: string,
  api?: string
) => {
  if (!api) throw Error("No api url");

  const url = !variables?.amount
    ? `${api}/items/gift-certificates/${variables.giftcardId}`
    : `${api}/items/gift-certificates/${variables.giftcardId}/amount/${variables.amount}`;

  const res = await fetch(
    url,

    {
      method: "POST",
      headers: { "API-token": customerToken || "" },
    }
  );

  const data = await res.json();

  if (data === null) throw Error("Error adding product to cart");
  return data;
};

export const useAddToCart = () => {
  const { config } = useConfig();
  const queryClient = useQueryClient();
  const { token } = useToken();

  const api = config?.centra.url;

  const addToCart = useMutation(
    async (variables: { giftcardId: string; amount?: number }) =>
      addProductToCart(variables, token, api),
    {
      onError: async (error: Error) => {
        console.error("error", error);
        queryClient.invalidateQueries({ queryKey: ["selection"] });
        return error;
      },
      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: ["selection"] });
      },
    }
  );

  return { addToCart };
};
